// removed by extract-text-webpack-plugin
module.exports = {"postTxnCardContainer":"postTxnCardContainer__1a5Gl","headingTextContainer":"headingTextContainer__1Ddtl","postTxnTextContainer":"postTxnTextContainer__3xFDS","textContainer":"textContainer__3Lbjj","cardlessEmiText":"cardlessEmiText__22qdV","subText":"subText__3odLT","logoImage":"logoImage__17nc_"};


//////////////////
// WEBPACK FOOTER
// ./componentsBICRevamp/buyWithInstacredLanding/preApprovedCard/postTxnContainer/style.css
// module id = UzKS
// module chunks = 323